meedy.factory('meedy.agreementService', ['$http', '$q', '$rootScope', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($http, $q, $rootScope, baseService, objectHelper, config) {

        function AgreementService() {

            this.download = function (token, fileType) {
                var d = $q.defer();

                $http({
                    url :  config.API_URL + '/agreements/personalData/nip/' + token,
                    method : 'GET',
                    params : {},
                    headers : {
                        'Content-type' : 'application/pdf'
                    },
                    responseType : 'arraybuffer'
                }).success(function(data, status, headers, config) {
                    var file = new Blob([ data ], {
                        type : 'application/pdf'
                    });

                    var fileURL = URL.createObjectURL(file);
                    var a         = document.createElement('a');
                    a.href        = fileURL;
                    a.target      = '_blank';
                    a.download    = 'Umowa';

                    document.body.appendChild(a);
                    a.click();

                    d.resolve(data);
                }).error(function(data, status, headers, config) {
                    d.reject(data);
                });

                return d.promise;
            };
        }

        return new AgreementService();
    }
]);
